import { useMemo } from 'react';
import { connect } from 'react-redux';
import { iconList } from '../../../utils/sidebarConfig';
import { Badge } from 'shards-react';

const NavItemIcon = ({ counter, iconClass }) => {
	const badgeStyle = useMemo(
		() => ({
			bottom: '1%',
			left: '5%',
			fontSize: 'x-small',
		}),
		[]
	);

	return (
		<>
			<i className={iconList[iconClass]} />
			{counter > 0 && (
				<Badge pill theme='danger' className='position-absolute' style={badgeStyle}>
					{counter}
				</Badge>
			)}
		</>
	);
};

const mapStateToProps = ({ docListStatus }, { serviceId, startStatus }) => {
	return {
		counter: typeof docListStatus?.[serviceId] === 'number' ? docListStatus[serviceId] : startStatus,
	};
};

export default connect(mapStateToProps)(NavItemIcon); //Export component and connect it with redux.
